"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sineWaveFactory = function (amplitude, ordinaryFrequency, phase) {
    if (amplitude === void 0) { amplitude = 1; }
    if (ordinaryFrequency === void 0) { ordinaryFrequency = 1; }
    if (phase === void 0) { phase = 0; }
    return function (x) {
        return Math.sin(x * 2 * Math.PI * ordinaryFrequency + phase) * amplitude;
    };
};
exports.fixedFactory = function (y) {
    return function () {
        return y;
    };
};
exports.powerFactory = function (power) {
    if (power === void 0) { power = 1; }
    return function (x) {
        return Math.pow(x, power);
    };
};
// Derived from Penner's elastic easing (http://robertpenner.com/easing/)
exports.bounceFactory = function (baseline) {
    if (baseline === void 0) { baseline = 2.75; }
    var baselinePow2 = Math.pow(baseline, 2);
    return function (x) {
        var offset = 0;
        var moduleX = x;
        if (moduleX < 8 / 22) {
            // Nothing
        }
        else if (moduleX < 16 / 22) {
            moduleX -= 12 / 22;
            offset = 3 / 4;
        }
        else if (moduleX < 20 / 22) {
            moduleX -= 18 / 22;
            offset = 15 / 16;
        }
        else {
            moduleX -= 21 / 22;
            offset = 63 / 64;
        }
        return baselinePow2 * moduleX * moduleX + offset;
    };
};
exports.doubleArcFactory = function (max) {
    if (max === void 0) { max = 1.1; }
    if (max <= 1) {
        throw new RangeError("Max value must be greater than 1, is " + max);
    }
    return function (x) {
        var y;
        if (x <= 0.5) {
            var mx = 1 - x * 2;
            y = Math.sqrt(Math.abs(Math.pow(mx, 2) - 1)) * max;
        }
        else {
            var mx = (x - 0.5) * 2;
            y = Math.sqrt(Math.abs(Math.pow(mx, 2) - 1)) * (max - 1) + 1;
        }
        return y;
    };
};
